import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">ProSolve Global Solutions</h3>
            <p className="footer-subtitle">Recovery Houses</p>
            <p className="footer-text">
              Safe, structured recovery housing for men and women rebuilding their lives in the Lehigh Valley, Pennsylvania.
            </p>
            <p className="footer-text" style={{ marginTop: '0.75rem' }}>
              <Mail size={16} style={{ verticalAlign: 'middle', marginRight: 6 }} />
              <a href="mailto:Admin@prosolveglobalsolutions.com" className="footer-link">Admin@prosolveglobalsolutions.com</a>
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Recovery Housing</h4>
            <ul className="footer-links">
              <li><Link to="/recovery-housing/" className="footer-link">Recovery Housing</Link></li>
              <li><Link to="/mens-recovery-housing/" className="footer-link">Men's Recovery Housing</Link></li>
              <li><Link to="/womens-recovery-housing/" className="footer-link">Women's Recovery Housing</Link></li>
              <li><Link to="/sober-living/" className="footer-link">Sober Living</Link></li>
              <li><Link to="/transitional-recovery-housing/" className="footer-link">Transitional Housing</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Locations & Funding</h4>
            <ul className="footer-links">
              <li><Link to="/recovery-housing-lehigh-valley-pa/" className="footer-link">Lehigh Valley, PA</Link></li>
              <li><Link to="/recovery-housing-whitehall-pa/" className="footer-link">Whitehall, PA</Link></li>
              <li><Link to="/recovery-housing-catasauqua-pa/" className="footer-link">Catasauqua, PA</Link></li>
              <li><Link to="/recovery-housing-funding-assistance/" className="footer-link">Funding & Scholarships</Link></li>
              <li><Link to="/resources/" className="footer-link">Resources & FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Women's Recovery House</h4>
            <div className="contact-item">
              <MapPin size={18} className="contact-icon" />
              <div><p>425 Walnut Street, Catasauqua, PA 18032</p></div>
            </div>
            <div className="contact-item">
              <Phone size={18} className="contact-icon" />
              <a href="tel:610-443-0175" className="footer-link">610-443-0175</a>
            </div>

            <h4 className="footer-heading" style={{ marginTop: '1.25rem' }}>Men's Recovery Houses</h4>
            <div className="contact-item">
              <MapPin size={18} className="contact-icon" />
              <div><p>Whitehall, PA</p></div>
            </div>
            <div className="contact-item">
              <Phone size={18} className="contact-icon" />
              <a href="tel:570-579-7695" className="footer-link">570-579-7695</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} ProSolve Global Solutions Recovery Houses. All rights reserved.</p>
          <p>DDAP Licensed Recovery Residences</p>
          <p className="footer-disclaimer">
            PGSRH provides structured recovery housing and peer support. We do not provide detox, rehab, therapy, counseling, or medical services.
            Funding or scholarship options may be available depending on eligibility and current availability; approval is never guaranteed.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
